import { render, staticRenderFns } from "./ClassroomAttachmentCard.vue?vue&type=template&id=428111c7&scoped=true&"
import script from "./ClassroomAttachmentCard.vue?vue&type=script&lang=js&"
export * from "./ClassroomAttachmentCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomAttachmentCard.vue?vue&type=style&index=0&id=428111c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428111c7",
  null
  
)

export default component.exports